



































































import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { ExChoice } from '../../interfaces/ExDataSet';

const globals = namespace("globals");

@Component({
    components: {
    }
})
export default class CompChoice extends Vue {
  @Prop() choice!: ExChoice;
  @Prop() disableVerifyButton!: boolean;
  @Prop() noSuccessAnimation!: boolean; // True for exercise type is Survey
  @Prop() finalized!: boolean;
  isClicked: boolean = false;
  showSuccessCheck: boolean = false;
  showFailedCheck: boolean = false;

  $refs!: {
    choiceButton: any;
  };

  mounted() {}

  // @Watch("disableVerifyButton")
  // async setFocusOnVerifyButton(val: boolean) {
  //   if (!val) {
  //     await this.$globalHelper.delay(10);
  //     this.$refs.choiceButton.$el.focus();
  //   }
  // }

  @Watch("finalized")
  async onFinalized(val: boolean) {
    if (val == false) {
      this.isClicked = false;
      this.showSuccessCheck = false;
      this.showFailedCheck = false;
      return;
    }

    if (this.choice.isVerifyButton && !this.noSuccessAnimation) {
      if (this.choice.isRight)
        this.showSuccessCheck = true;
      else
        this.showFailedCheck = true;
    }

    // this.choice.clickDisabled = true;
    // if (this.choice.isRight) {
    //     this.choice.state = "T";
    // }
    // else {
    //   this.choice.state = "F";
    // }
  }

  get disabled() {
    if (this.choice.isVerifyButton && this.disableVerifyButton)
      return true;
    return false;
  }

  get statusMessage() {
    // Verify Button is used for single and multiple choice questions.
    // This components will announce the result by there own.
    // if (this.choice.isVerifyButton && this.finalized) {
    //   if (this.choice.isRight) {
    //     return "Auswahl war richtig!";
    //   } else if (this.isClicked) {
    //     return "Auswahl war falsch!";
    //   }
    // }

    if (this.choice.isVerifyButton == false && this.finalized) {
      if (this.choice.isRight) {
        return `Richtige Antwort: ${this.choice.lable}`;
      } else if (this.isClicked) {
        return `Falsche Antwort: ${this.choice.lable}`;
      }
    }

    return "";
  }

  get buttonAriaLabel() {
    if (this.choice.isVerifyButton) {
      if (this.disabled) {
        return `${this.choice.lable} - Nicht verfügbar. Erst Antworten auswählen.`;      }
      return this.choice.lable;
    }

    if (this.finalized) {
      return `Antwort: ${this.choice.lable} - ${this.choice.isRight ? ' ist richtig' : ' ist falsch'}`;
    }

    return this.choice.lable;
  }

  checkAnswer() {
    if (this.finalized)
      return;

    if (this.noSuccessAnimation){
      this.$emit('next:CompChoice');
      return;
    }

    this.isClicked = true;

    if (this.choice.isVerifyButton) {
      this.$emit('verify:CompChoice');
      return;
    }

    if (this.choice.isRight) {
      // this.choice.state = "T";
      this.showSuccessCheck = true;
      this.$emit('succeded:CompChoice', true, false);
    } else {
      // this.choice.state = "F";
      this.showFailedCheck = true;
      this.$emit('succeded:CompChoice', false, false);
    }
  }
}
